import { Component, OnInit,Inject, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { WatcherService } from 'src/app/services/watcher.service';

@Component({
    selector: 'create-shipment-error-dialog',
    templateUrl: 'create-shipment-error-dialog.html',

})
export class CreateShipmentErrorDialog implements OnDestroy , OnInit{
    lang; 
    constructor(
        public dialogRef: MatDialogRef<CreateShipmentErrorDialog>,
        private router: Router, 
        private watcherService: WatcherService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }
    ngOnInit(): void {
        this.watcherService.getLang().subscribe(
            lang => {
              this.lang = lang;
            }
          )
    }
    closeDialog() {
        this.router.navigate(['/','b2b', 'shipments'])
        this.dialogRef.close();

    }
    ngOnDestroy(): void {
        this.dialogRef.close();
    }
}